import gql from "graphql-tag";

/**
 * All distinct make/model pairs available in the static vehicle catalog.
 *
 * Backed by the `vehicle_catalog_make_model` SQL view (MVP-2.1), which Postgres
 * reduces to DISTINCT (make, model). This is bounded (low thousands) and stable
 * regardless of catalog size — unlike the old `allVehicleCatalogs(first: 20000)`
 * which pulled every raw row (~70k for the full Teoalida file). The `first`
 * cap here is a safety bound over distinct PAIRS, not raw rows, so it scales.
 */
export default gql`
  query getCatalogMakesModels {
    allVehicleCatalogMakeModels(first: 20000) {
      nodes {
        make
        model
      }
    }
  }
`;
